import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleChevronUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2C6.47715 2 2 6.47716 2 12C2 17.5229 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 13.5L12 9.5L16 13.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCircleChevronUp.js.map